import { NgModule } from '@angular/core';
import { ContactInfoFormModule } from 'app/components/contact-info/contact-info.module';
import { SharedModule } from 'app/shared/shared.module';
import { QuickCreateAssetComponent } from './quick-create-asset.component';

@NgModule({
    declarations: [
        QuickCreateAssetComponent,
    ],
    imports: [
        SharedModule,
        ContactInfoFormModule
    ],
    exports: [
        QuickCreateAssetComponent
    ]
})
export class QuickCreateAssetModule { }
